<template>
    <el-dialog
            style="text-align: left"
            title="修改小组分派单"
            :visible.sync="show"
            width="45%"
            @closed="closed"
    >
        <el-form :model="formData" label-width="auto">
            <el-form-item size="mini" label="结算状态:">
                <el-select v-model="formData.finance_status">
                    <el-option v-for="option in financeStatusOptions"
                               :key="option.value"
                               :value="option.value"
                               :label="option.label">
                    </el-option>
                </el-select>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button size="mini" @click="show=false">取 消</el-button>
            <el-button :loading="loading" @click="send" size="mini" type="primary">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
    import {mapMutations} from 'vuex'
    export default {
        name: "GroupOrderModify",
        data() {
            return {
                loading: false,
                show: false,
                formData: {
                    finance_status: '',
                },
                currentId: '',
                _current_Group: '',

                financeStatusOptions: [
                    {label: '未结算', value: 0},
                    {label: '已结算', value: 1},
                    {label: '作废', value: -1},
                ],
            }
        },
        methods: {
            open(groupCraft) {
                this.show = true
                this.formData.finance_status = groupCraft.finance_status
                this.currentId = groupCraft.id
                this._current_Group = groupCraft
            },
            close(){
                this.show=false
            },
            closed(){
                this.formData.finance_status = ''
                this._current_Group = ''
                this.currentId = ''
            },

            send() {
                this.loading = true
                const data = {
                    finance_status: this.formData.finance_status,
                    simple:true
                }
                const url = `${this.$const.craftGroupRecordUrl}${this.currentId}/`
                this.$patchRequest(url, data)
                    .then(response => {
                        this.loading = false
                        const newGroupCraft = JSON.parse(JSON.stringify(this._current_Group))
                        newGroupCraft.finance_status = this.formData.finance_status
                        this.addGroupCrafts([newGroupCraft])
                        this.close()
                    })
                    .catch(error => {
                        this.loading = false
                    })
            },
            ...mapMutations(['addGroupCrafts'])
        },
    }
</script>

<style scoped>

</style>